import React, { Component } from 'react';
import { ErrorMessage } from 'formik';
import { BTFieldValError } from './BTFieldValError';
import CustomErrorMessage from 'globals/CustomErrorMessage';

export class BTInputField extends Component {
     constructor(props) {
          super(props);
          this.state = {
               formData: {
                    [this.props.id]: '',
               },
               errors: {
                    [this.props.id]: '',
               },
               touched: {
                    [this.props.id]: false,
               }
          }
     }

     handleBlur = (e) => {
          const { name, value } = e.target;

          this.setState({
               errors: { [this.props.id]: value === "" ? `${this.props.id} is empty` : '' },
               touched: { [this.props.id]: true }, formData: { [this.props.id]: value }
          }, () => {
               this.props.handleBlur && this.props.handleBlur(e);
          });

     };

     togglePasswordVisibility = () => {
          this.setState(prevState => ({
               passwordVisible: !prevState.passwordVisible
          }));
     }

     render = () => {
          let isFieldEmpty = !!!this.props.value;
          const { className, type } = this.props;
          const isPassword = type === 'password';
          const inputType = isPassword ? (this.state.passwordVisible ? 'text' : 'password') : (type || 'text');

          return (

               <div className={`form-group ${className ? className : ''}`}>
                    <label className="body2">{this.props.label}
                         {
                              this.props.required ? <span className="error">*</span> : <div className="optional">&nbsp;( optional )</div>
                         }
                    </label>
                    <div style={{ position: 'relative' }}>
                         <input type={inputType}
                              min={this.props.min} max={this.props.max}
                              readOnly={this.props.readonly}
                              disabled={this.props.disabled}
                              autoComplete={this.props.autoComplete}
                              name={this.props.id} id={this.props.id} className={`form-control ${isFieldEmpty ? 'input-empty' : ''}`}
                              onBlur={this.handleBlur}
                              placeholder={this.props.placeholder ? this.props.placeholder : 'Enter here'}
                              value={this.props.value} onChange={this.props.handleChange}
                              onFocus={(e) => {
                                   if (this.props.allowReadOnlyOnfocus) {
                                        e.target.removeAttribute('readOnly');
                                   }
                              }}
                              style={isPassword ? { paddingRight: '40px' } : {}}
                         />
                         {isPassword && (
                              <img
                                   src={this.state.passwordVisible ? '/images/icons/icon-view.svg' : '/images/icons/icon-view.svg'}
                                   alt="toggle password visibility"
                                   onClick={this.togglePasswordVisibility}
                                   className="password-toggle-icon"
                                   style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        cursor: 'pointer',
                                        width: '20px',
                                        opacity: this.state.passwordVisible ? 1 : 0.5
                                   }}
                              />
                         )}
                    </div>
                    <CustomErrorMessage
                         name={this.props.id}
                         errors={this.props.errors || this.state.errors}
                         touched={this.props.touched || this.state.touched}
                         CustomComponent={BTFieldValError}
                    />
               </div>


          );
     }
}